import { render } from "./GroupClassPlanCreateGoal.vue?vue&type=template&id=7a3a2fe9&scoped=true"
import script from "./GroupClassPlanCreateGoal.vue?vue&type=script&lang=js"
export * from "./GroupClassPlanCreateGoal.vue?vue&type=script&lang=js"

import "./GroupClassPlanCreateGoal.vue?vue&type=style&index=0&id=7a3a2fe9&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a3a2fe9"]])

export default __exports__